"use strict";

exports.__esModule = true;
exports.bgGradient = exports.bgColorOrGradient = exports.bgColor = void 0;

var _styledComponents = require("styled-components");

var _colors = require("./colors");

var _system = require("./system");

var directionMap = {
  horizontal: "to right",
  horizontalInverted: "to left",
  vertical: "to bottom",
  verticalInverted: "to top"
};

var directionMapKeyToValue = function directionMapKeyToValue(direction, inverted) {
  if (!direction) {
    return inverted ? "to left" : "to right";
  }

  return inverted ? directionMap[direction + "Inverted"] : directionMap[direction];
};

var bgColor = function bgColor(color, version) {
  if (version === void 0) {
    version = "1.0";
  }

  return color ? (0, _styledComponents.css)(["background-color:", ";"], (0, _system.colors)(color, version)) : null;
};

exports.bgColor = bgColor;

var bgGradient = function bgGradient(color, direction, inverted, version) {
  if (inverted === void 0) {
    inverted = false;
  }

  if (version === void 0) {
    version = "1.0";
  }

  return (0, _styledComponents.css)(["background-color:", ";background:linear-gradient( ", ",", " );"], (0, _system.colors)(color, version), directionMapKeyToValue(direction, inverted), (0, _colors.brandGradientColors)(color, version));
};

exports.bgGradient = bgGradient;

var bgColorOrGradient = function bgColorOrGradient(bgColorName, bgGradientColorName, bgGradientDirection, inverted, version) {
  if (inverted === void 0) {
    inverted = false;
  }

  if (version === void 0) {
    version = "1.0";
  }

  return bgGradientColorName ? (0, _styledComponents.css)(["", ";"], bgGradient(bgGradientColorName, bgGradientDirection, inverted, version)) : (0, _styledComponents.css)(["", ";"], bgColor(bgColorName, version));
};

exports.bgColorOrGradient = bgColorOrGradient;